/**
 * Authenticated fetch wrapper.
 * Automatically injects the JWT token from localStorage into every request.
 * On 401 responses, clears auth state and redirects to /login.
 */
import { clearAuthProfile } from './permissions';

let isRedirecting = false;

export default async function authFetch(url, options = {}) {
  const token = localStorage.getItem('authToken');

  // Merge Authorization header into existing headers
  const headers = { ...options.headers };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, { ...options, headers });

  // If the server says unauthorized, log the user out (once)
  // Don't redirect if already on the login page to avoid infinite loops
  if (response.status === 401 && !isRedirecting && !window.location.pathname.startsWith('/login')) {
    isRedirecting = true;
    localStorage.removeItem('authToken');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('leadGenUser');
    clearAuthProfile();
    window.location.href = '/login';
    throw new Error('Authentication required');
  }

  return response;
}
